import { render, staticRenderFns } from "./DepartmentsPage.vue?vue&type=template&id=7d0e4f5a&scoped=true&"
import script from "./DepartmentsPage.vue?vue&type=script&lang=js&"
export * from "./DepartmentsPage.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentsPage.vue?vue&type=style&index=0&id=7d0e4f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0e4f5a",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/departments_page.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fdepartment%2FDepartmentsPage.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports